import ModelFactory from '../model-factory';

import BaseModel from '../models/base-model';
import User from '../user/model';

export default class ZapprlWorkFlow extends BaseModel {
  constructor(data = {}) {
    super(data);
    this.id = data.id || null;
    this.order = data.zorder || null;

    this.status = data.zstatus || null;
    this.contact = null;
    if (data.contact != null) {
      this.contact = new User(data.contact);
    }
  }
}

export const modelFactory = new ModelFactory('zapprl_workflow', (data) => new ZapprlWorkFlow(data));
